/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetNextActionTypes200Response } from '../models';
/**
 * NextActionTypeApi - axios parameter creator
 * @export
 */
export const NextActionTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 次のアクションタイプ一覧取得API
         * @summary 次のアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/next_action_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NextActionTypeApi - functional programming interface
 * @export
 */
export const NextActionTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NextActionTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 次のアクションタイプ一覧取得API
         * @summary 次のアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextActionTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextActionTypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextActionTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NextActionTypeApi - factory interface
 * @export
 */
export const NextActionTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NextActionTypeApiFp(configuration)
    return {
        /**
         * 次のアクションタイプ一覧取得API
         * @summary 次のアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionTypes(options?: any): AxiosPromise<GetNextActionTypes200Response> {
            return localVarFp.getNextActionTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NextActionTypeApi - interface
 * @export
 * @interface NextActionTypeApi
 */
export interface NextActionTypeApiInterface {
    /**
     * 次のアクションタイプ一覧取得API
     * @summary 次のアクションタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionTypeApiInterface
     */
    getNextActionTypes(options?: AxiosRequestConfig): AxiosPromise<GetNextActionTypes200Response>;

}

/**
 * NextActionTypeApi - object-oriented interface
 * @export
 * @class NextActionTypeApi
 * @extends {BaseAPI}
 */
export class NextActionTypeApi extends BaseAPI implements NextActionTypeApiInterface {
    /**
     * 次のアクションタイプ一覧取得API
     * @summary 次のアクションタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionTypeApi
     */
    public getNextActionTypes(options?: AxiosRequestConfig) {
        return NextActionTypeApiFp(this.configuration).getNextActionTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
